// extracted by mini-css-extract-plugin
export default {"container":"hN-z","topReviewHeading":"iN-z","criticalReview":"jN-z","favorableReview":"kN-z","vsSeparator":"lN-z"};